import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import Input from '../../Components/Input/Input';
import Button from '../../Components/Button/Button';
import { postApi } from '../../Services/apiService';

export default function AdminLogin() {
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [formData, setFormData] = useState({ email: '', password: '' });
  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: '' }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const nextErrors = {};
    if (!formData.email.trim()) {
      nextErrors.email = 'Email is required';
    } else if (!/\S+@\S+\.\S+/.test(formData.email.trim())) {
      nextErrors.email = 'Email is invalid';
    }
    if (!formData.password) nextErrors.password = 'Password is required';
    if (Object.keys(nextErrors).length) {
      setErrors(nextErrors);
      return;
    }

    setIsLoading(true);
    setErrors({});

    try {
      const response = await postApi('/admin/login', {
        email: formData.email.trim(),
        password: formData.password,
      });

      if (response?.statusCode === 200) {
        const userDetails =
          response?.user_details ||
          response?.data?.user_details ||
          response?.data ||
          {};
        const token = userDetails?.token || response?.token;

        localStorage.setItem('adminAuth', 'true');
        localStorage.setItem('adminLoginResponse', JSON.stringify(response));

        if (userDetails && Object.keys(userDetails).length > 0) {
          localStorage.setItem('adminData', JSON.stringify(userDetails));
        }
        if (token) {
          localStorage.setItem('token', token);
        }

        toast.success(response?.message || 'Login successful');
        navigate('/admin/dashboard');
      } else {
        const errorMessage = response?.message || 'Login failed. Please check your credentials.';
        setErrors({ submit: errorMessage });
        toast.error(errorMessage);
      }
    } catch (error) {
      const errorMessage =
        error?.response?.data?.message || error?.message || 'Login failed. Please try again.';
      setErrors({ submit: errorMessage });
      toast.error(errorMessage);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-container">
        <div className="login-info">
          <div className="login-logo">
            <Link to="/">
              <img src={window.getPublicUrl('/assets/images/Logo.png')} alt="ClearRent" className="login-logo-img" />
            </Link>
          </div>
          <h1 className="login-welcome">Welcome back</h1>
          <p className="login-description">
            Access your admin dashboard to manage properties, tenants, landlords, and platform revenue.
          </p>
        </div>
        <div className="login-form-section">
          <h2 className="login-form-title">Sign in</h2>
          <p className="login-form-subtitle">Enter your credentials to access the admin panel</p>
          <form
            onSubmit={handleSubmit}
            className={`login-form-card ${Object.keys(errors).length > 0 ? 'has-errors' : ''}`}
            noValidate
          >
            <div className="login-form-header">Account Information</div>
            <div className={`login-form-fields ${Object.keys(errors).length > 0 ? 'has-errors' : ''}`}>
              <Input
                type="email"
                name="email"
                label="Email"
                placeholder="Eg. admin@clearrent.com"
                value={formData.email}
                onChange={handleChange}
                error={errors.email}
                required
              />
              <div className="login-password-wrapper">
                <div className="login-password-label-row">
                  <label htmlFor="admin-password" className="input-label">
                    Password
                    <span className="required">*</span>
                  </label>
                </div>
                <div className="login-password-input-wrapper">
                  <input
                    type={showPassword ? 'text' : 'password'}
                    id="admin-password"
                    name="password"
                    placeholder="Eg. 451234nnkdk451"
                    value={formData.password}
                    onChange={handleChange}
                    required
                    className={`input-field ${errors.password ? 'input-error' : ''}`.trim()}
                  />
                  <button
                    type="button"
                    className="login-password-toggle"
                    onClick={() => setShowPassword(!showPassword)}
                  >
                    <img
                      src={window.getPublicUrl(
                        showPassword ? '/assets/images/Eye.svg' : '/assets/images/eye-closed.svg'
                      )}
                      alt={showPassword ? 'Hide password' : 'Show password'}
                      className="login-eye-icon"
                    />
                  </button>
                </div>
                <div className={`error-message-container ${errors.password ? 'has-error' : ''}`}>
                  {errors.password && <span className="error-message">{errors.password}</span>}
                </div>
              </div>
            </div>
            {errors.submit && (
              <div className="error-message-container has-error" style={{ marginBottom: '1rem' }}>
                <span className="error-message">{errors.submit}</span>
              </div>
            )}
            <Button type="submit" variant="success" className="login-submit-button" disabled={isLoading}>
              {isLoading ? 'Signing in...' : 'Continue'}
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
}
